import React from "react";

// reactstrap components
import {
  Alert,
  Card,
  CardHeader,
  Col,
  CardFooter,
  Container,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
// core components
import LoyaltyTable from "components/Tables/Loyalty";
import Header from "components/Headers/LoyaltyHeader";
import LoyaltyDataService from "../../services/LoyaltyDataService";

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loyaltyMembers: [],
      topLoyaltyMembers: [],
      perPage: 10,
      currentPage: 1,
    };
    this.LoyaltyDataService = new LoyaltyDataService();
  }

  componentDidMount() {
    this.fetchData()
    this.fetchTopMembers()
  }

  fetchData() {
    this.LoyaltyDataService.getLoyaltyList(this.state.currentPage, this.state.perPage)
      .then(res => this.setState(res));
    setTimeout(() => {
      this.setState({ errorMessage: undefined })
    }, 5000);
  }

  fetchTopMembers() {
    this.LoyaltyDataService.getTopLoyaltyMembers()
      .then(res => this.setState(res));
  }

  handlePageClick = (e) => {
    const selectedPage = e;

    this.setState({
      currentPage: selectedPage,
    }, () => {
      this.fetchData()
    });
  }

  handleNextPageClick() {
    this.handlePageClick(this.state.currentPage + 1)
  }

  handlePreviousPageClick() {
    this.handlePageClick(this.state.currentPage - 1)
  }

  render() {
    const pageNumbers = [];
    for (var index = 1; index <= this.state.totalPages; index++) {
      pageNumbers.push(index)
    }

    const renderPageNumbers = pageNumbers.map(number => {
      return (
        <PaginationItem key={number} className={this.state.currentPage === number ? "active" : ""}>
          <PaginationLink
            onClick={() => this.handlePageClick(number)}
          >
            {number}
          </PaginationLink>
        </PaginationItem>
      )
    })

    return (
      <>
        <Header topLoyaltyMembers={this.state.topLoyaltyMembers} />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Daftar member loyalitas</h3>
                    </Col>
                    {this.state.errorMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="danger">
                          {this.state.errorMessage}
                        </Alert>
                      </Col>
                    )}
                  </Row>
                </CardHeader>
                <LoyaltyTable
                  loyaltyMembers={this.state.loyaltyMembers}
                />
                <CardFooter className="py-4">
                  {this.state.totalPages > 1 && (
                    <nav aria-label="...">
                      <Pagination
                        className="pagination justify-content-end mb-0"
                        listClassName="justify-content-end mb-0"
                      >
                        <PaginationItem className={this.state.currentPage === 1 && "disabled"}>
                          <PaginationLink
                            onClick={() => this.handlePreviousPageClick()}
                            tabIndex="-1"
                          >
                            <i className="fas fa-angle-left" />
                            <span className="sr-only">Previous</span>
                          </PaginationLink>
                        </PaginationItem>
                        {renderPageNumbers}
                        <PaginationItem className={this.state.currentPage === this.state.totalPages && "disabled"}>
                          <PaginationLink
                            onClick={() => this.handleNextPageClick()}
                          >
                            <i className="fas fa-angle-right" />
                            <span className="sr-only">Next</span>
                          </PaginationLink>
                        </PaginationItem>
                      </Pagination>
                    </nav>
                  )}
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default List;
